import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    username: '',
    email: '',
    profile: {},
    randomUserList: [],
    accessToken: '',
    refreshToken: '',
    currentChatUsers: [],
    messages: [],
    message: '',
    img: '',
    msgNotify: [],
    userList: [],
    chattingWith: {},
    socket: null,
    viewProfile: {},
    favorites: [],
    blocks: [],
    server: process.env.VUE_APP_SERVER_URL,
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})
